cv.PostsRowView = Marionette.LayoutView.extend({
  tagName: 'div',
  className: 'post',
  template: cv.Templates['posts/row'],

  events : {
  },

  templateHelpers: function(){
    return {
      id : this.model.get('id'),
      title : this.model.get('status') == 1 ? this.model.get('share_title') : this.model.get('draft_title'),
      has_photo : (this.model.get('status') == 1 && this.model.get('share_image') != '') || (this.model.get('status') == 0 && this.model.get('draft_image') != '') ? true : false,
      photo_path : cv.photo({
        photo_path : this.model.get('status') == 1 ? this.model.get('share_image') : this.model.get('draft_image'),
        transforms : {
          fit : 'crop'
        },
        url_only : true
      }),
      url : this.model.get('url'),
      description : this.model.get('status') == 1 ? this.model.get('share_description') : this.model.get('draft_description'),
      author_stub : this.model.get('author.stub'),
      author_name : this.model.get('author.first_name') + ' ' + this.model.get('author.last_name'),
      author_photo_path : cv.photo({
        photo_path : this.model.get('author.photo_path'),
        transforms : {
          fit : 'crop'
        },
        url_only : true
      }),
      created_at : moment(this.model.get('created_at') + 'Z').tz(cv.campaign.get('timezone')).format('MMM D'),
      published_at : moment(this.model.get('published_at') + 'Z').tz(cv.campaign.get('timezone')).format('MMM D'),
      is_published : this.model.get('status') == 1 ? true : false,
      has_unpublished_changes : this.model.get('status') == 1 && this.model.get('draft') != this.model.get('body') ? true : false
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    
    console.log('PostsRowView initialized');
  },

  onAttach: function(){
    imgix.fluid(this.$el.get(0), {
      rootNode: this.$el.get(0),
      updateOnResizeDown: false,
      autoInsertCSSBestPractices: true
    });
  }
});
